import { Fragment, useState } from "react";
import { Transition } from "@headlessui/react";
import {connect} from 'react-redux';
import { formatDistanceToNow } from 'date-fns'
import {GiftIcon} from '@heroicons/react/24/outline';

import {Actions as NOTIFICATIONACTIONS} from 'store/actions/adventCalendarActions';



function Notification({notification,closeNotification,addNotification, items}) {
	const [show, setShow] = useState(true);

	if (!notification){
		return null;
	}
	return (
		<>
			{/* Global notification live region, render this permanently at the end of the document */}
			<div
				aria-live="assertive"
				className="pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-end sm:p-6 z-40"
			>
				<div className="flex w-full flex-col items-center space-y-4 sm:items-end">
					{/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
					<Transition
						show={show}
						as={Fragment}
						enter="transform ease-out duration-300 transition"
						enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
						enterTo="translate-y-0 opacity-100 sm:translate-x-0"
						leave="transition ease-in duration-100"
						leaveFrom="opacity-100"
						leaveTo="opacity-0"
					>
						<div
							className="pointer-events-auto flex w-full max-w-md rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5">
							<div className="w-0 flex-1 p-4">
								<div className="flex items-start">
									<div className="flex-shrink-0 pt-0.5">
										<img
											className="h-10 w-10 rounded-full"
											src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2.2&w=160&h=160&q=80"
											alt=""
										/>
									</div>
									<div className="ml-3 w-0 flex-1">
										<p className="text-sm font-medium text-gray-900">Someone from {notification.location}</p>
										<p className="mt-1 text-sm text-gray-500">donated {items.find(i => i.id === notification.itemDonated)?.name} {formatDistanceToNow(Date.parse(notification.openedAt))} ago</p>
									</div>
									<div>
										<GiftIcon className="w-10 h-10"/>
									</div>
								</div>
							</div>
						</div>
					</Transition>
				</div>
			</div>
		</>
	);
}


const mapStateToProps = (state) => {
	return {
		notification: state.adventCalendar.notifications[0],
		items: state.adventCalendar.items,
	};
};

const mapDispatchToProps = dispatch => ({
	addNotification: (notification,removeAfter) => dispatch(NOTIFICATIONACTIONS.addNotification(notification,removeAfter)),
	closeNotification: (id) => dispatch(NOTIFICATIONACTIONS.closeNotification(id))
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Notification);